function bindHeroWidget(widget) {
  const toggle = widget.querySelector("[data-speakers-hero-toggle]");

  if (!toggle || toggle.dataset.speakersHeroBound === "true") {
    return;
  }

  const setExpanded = (expanded) => {
    widget.classList.toggle("is-collapsed", !expanded);
    toggle.classList.toggle("is-expanded", expanded);
    toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    toggle.setAttribute("aria-label", expanded ? "Close Speakers Bureau links" : "Open Speakers Bureau links");
  };

  toggle.addEventListener("click", () => {
    setExpanded(toggle.getAttribute("aria-expanded") !== "true");
  });

  setExpanded(true);
  toggle.dataset.speakersHeroBound = "true";
}

export default function initSpeakersBureau(root = document) {
  root.querySelectorAll("[data-speakers-hero-widget]").forEach(bindHeroWidget);
}
